import type { ICard } from "../../cardsSlice";

export const swordsData: ICard[] = [
{
    id: "swords_1",
    arcana: "minor",
    suit: "swords",
    court: "simple",
    number: 1,
    name: "Туз Мечей",
    nameEn: "Ace of Swords",

    keywords: ["Истина", "Ясность", "Прорыв"],

    symbolism: [
      "Рука из облака держит меч",
      "Корона с лаврами",
      "Горный пейзаж"
    ],
    symbolismInterpretation: "Момент истины, новая идея, прорыв в мышлении",

    archetype: "Меч разума",
    psychology: "Способность ясно мыслить и видеть суть",

    upright: {
      personality: "Прямота, решительность",
      relationships: "Честный разговор",
      work: "Новая стратегия",
      spirituality: "Осознание истины",
      examples: ["Разрешение конфликта", "Инсайт", "Победа в споре"]
    },
    reversed: {
      meaning: "Путаница, ложь",
      nuances: "Искажение информации"
    },

    associations: ["Меч", "Корона", "Горы"],
    combinations: [
      "С Магом — идея с потенциалом",
      "С Луной — борьба с иллюзиями"
    ],
    readingTips: [
      "Говорить прямо",
      "Отделять правду от лжи"
    ],
    selfQuestions: [
      "Что является истиной в этой ситуации?",
      "Где мне нужна ясность?"
    ]
  },
{
    id: "swords_2",
    arcana: "minor",
    suit: "swords",
    court: "simple",
    number: 2,
    name: "Двойка Мечей",
    nameEn: "Two of Swords",

    keywords: ["Выбор", "Нерешительность", "Баланс"],

    symbolism: [
      "Женщина с завязанными глазами держит два меча",
      "Море и луна на фоне",
      "Скрещённые руки"
    ],
    symbolismInterpretation: "Необходимость сделать выбор, внутренний конфликт",

    archetype: "Перекрёсток",
    psychology: "Закрытость новым данным, попытка сохранить баланс",

    upright: {
      personality: "Сдержанность, осторожность",
      relationships: "Отложенное решение",
      work: "Застой из-за сомнений",
      spirituality: "Поиск внутреннего равновесия",
      examples: ["Тупик", "Отказ смотреть правде в глаза"]
    },
    reversed: {
      meaning: "Принятие решения",
      nuances: "Разрыв внутреннего тупика"
    },

    associations: ["Луна", "Море", "Закрытые глаза"],
    combinations: [
      "С Колесницей — решительное движение вперёд",
      "С Семёркой Кубков — сложный выбор"
    ],
    readingTips: [
      "Собрать факты",
      "Снять внутренние блоки"
    ],
    selfQuestions: [
      "Что мешает мне принять решение?",
      "Чего я боюсь увидеть?"
    ]
  },
{
    id: "swords_3",
    arcana: "minor",
    suit: "swords",
    court: "simple",
    number: 3,
    name: "Тройка Мечей",
    nameEn: "Three of Swords",

    keywords: ["Разочарование", "Потеря", "Боль"],

    symbolism: [
      "Сердце, пронзённое тремя мечами",
      "Дождь и серое небо",
      "Отсутствие людей"
    ],
    symbolismInterpretation: "Эмоциональная боль, предательство, разлука",

    archetype: "Сердце боли",
    psychology: "Острый опыт потери и разочарования",

    upright: {
      personality: "Чувствительность к утратам",
      relationships: "Разрыв, измена",
      work: "Неудачный проект",
      spirituality: "Принятие страдания как части пути",
      examples: ["Разрыв отношений", "Потеря друга", "Срыв планов"]
    },
    reversed: {
      meaning: "Исцеление, прощение",
      nuances: "Смягчение боли"
    },

    associations: ["Сердце", "Дождь", "Мечи"],
    combinations: [
      "С Десяткой Мечей — окончательная точка",
      "С Звездой — надежда после боли"
    ],
    readingTips: [
      "Принять свои чувства",
      "Дать время на заживление"
    ],
    selfQuestions: [
      "Как я справляюсь с утратой?",
      "Готов ли я простить?"
    ]
  },
{
    id: "swords_4",
    arcana: "minor",
    suit: "swords",
    court: "simple",
    number: 4,
    name: "Четвёрка Мечей",
    nameEn: "Four of Swords",

    keywords: ["Отдых", "Восстановление", "Пауза"],

    symbolism: [
      "Рыцарь лежит на надгробии с мечом",
      "Три меча висят на стене",
      "Витраж с молитвой"
    ],
    symbolismInterpretation: "Время для восстановления сил и обдумывания",

    archetype: "Мир перед бурей",
    psychology: "Необходимость передышки и восстановления",

    upright: {
      personality: "Спокойствие, выдержка",
      relationships: "Перемирие",
      work: "Пауза перед новым этапом",
      spirituality: "Медитация, молитва",
      examples: ["Отпуск", "Восстановление после болезни"]
    },
    reversed: {
      meaning: "Вынужденная активность",
      nuances: "Беспокойство в период отдыха"
    },

    associations: ["Витраж", "Покой", "Мечи"],
    combinations: [
      "С Отшельником — глубокая внутренняя работа",
      "С Восьмёркой Жезлов — быстрое возвращение к делам"
    ],
    readingTips: [
      "Дать себе отдых",
      "Использовать паузу для планирования"
    ],
    selfQuestions: [
      "Достаточно ли я восстанавливаюсь?",
      "Чему я могу научиться в тишине?"
    ]
  },
{
    id: "swords_5",
    arcana: "minor",
    suit: "swords",
    court: "simple",
    number: 5,
    name: "Пятёрка Мечей",
    nameEn: "Five of Swords",

    keywords: ["Конфликт", "Поражение", "Самодовольство"],

    symbolism: [
      "Человек с мечами в руках и победной улыбкой",
      "Двое уходят",
      "Облака и ветер"
    ],
    symbolismInterpretation: "Победа любой ценой, горечь поражения",

    archetype: "Спорщик",
    psychology: "Эгоцентризм или чувство обиды",

    upright: {
      personality: "Амбициозность, упрямство",
      relationships: "Ссоры, упрёки",
      work: "Несправедливая конкуренция",
      spirituality: "Проверка моральных принципов",
      examples: ["Выигрыш в споре", "Разрыв отношений из-за конфликта"]
    },
    reversed: {
      meaning: "Примирение",
      nuances: "Отказ от борьбы"
    },

    associations: ["Мечи", "Ветер", "Облака"],
    combinations: [
      "С Пятёркой Жезлов — ожесточённая борьба",
      "С Звездой — поиск мирного решения"
    ],
    readingTips: [
      "Оценить последствия победы",
      "Не разрушать связи"
    ],
    selfQuestions: [
      "Стоит ли эта победа цены?",
      "Готов ли я к примирению?"
    ]
  },
{
    id: "swords_6",
    arcana: "minor",
    suit: "swords",
    court: "simple",
    number: 6,
    name: "Шестёрка Мечей",
    nameEn: "Six of Swords",

    keywords: ["Переход", "Исцеление", "Дорога"],

    symbolism: [
      "Лодка с людьми пересекает воду",
      "Шесть мечей в носу лодки",
      "Спокойная гладь и дальний берег"
    ],
    symbolismInterpretation: "Переход к более спокойной фазе, уход от конфликта",

    archetype: "Переправа",
    psychology: "Ментальное восстановление, уход от болезненной ситуации",

    upright: {
      personality: "Взвешенность, трезвость",
      relationships: "Пауза, дистанция ради мира",
      work: "Перевод проекта, смена направления",
      spirituality: "Путь исцеления",
      examples: ["Переезд", "Мирное урегулирование", "Терапия"]
    },
    reversed: {
      meaning: "Застревание, невозможность отпустить",
      nuances: "Поворот назад, откат в старые паттерны"
    },

    associations: ["Лодка", "Вода", "Переправа"],
    combinations: [
      "С Отшельником — внутреннее паломничество",
      "С Колесницей — целенаправленная смена курса"
    ],
    readingTips: [
      "Признать необходимость перехода",
      "Сфокусироваться на следующем берегу"
    ],
    selfQuestions: [
      "Что я оставляю позади?",
      "Где мой спокойный берег?"
    ]
  },
{
    id: "swords_7",
    arcana: "minor",
    suit: "swords",
    court: "simple",
    number: 7,
    name: "Семёрка Мечей",
    nameEn: "Seven of Swords",

    keywords: ["Стратегия", "Хитрость", "Избежание"],

    symbolism: [
      "Человек уносит пять мечей, два оставляет",
      "Лагерь на заднем плане",
      "Крадучая походка"
    ],
    symbolismInterpretation: "Действие в обход, тактика, скрытность",

    archetype: "Трикстер",
    psychology: "Страх прямого столкновения, манёвры",

    upright: {
      personality: "Находчивость, независимость",
      relationships: "Секреты, неискренность",
      work: "Обходные решения, одиночная работа",
      spirituality: "Личная тропа, неформальный путь",
      examples: ["Стратегический манёвр", "Сбор информации", "Работа в одиночку"]
    },
    reversed: {
      meaning: "Разоблачение, признание",
      nuances: "Возврат украденного, ответственность"
    },

    associations: ["Кража", "Следы", "Тишина"],
    combinations: [
      "С Справедливостью — раскрытие обмана",
      "С Тузом Мечей — честная стратегия вместо уловок"
    ],
    readingTips: [
      "Оценить этичность методов",
      "Просчитать риски разоблачения"
    ],
    selfQuestions: [
      "Почему я ухожу от прямого разговора?",
      "Какой честный способ эффективнее?"
    ]
  },
{
    id: "swords_8",
    arcana: "minor",
    suit: "swords",
    court: "simple",
    number: 8,
    name: "Восьмёрка Мечей",
    nameEn: "Eight of Swords",

    keywords: ["Ограничение", "Страх", "Беспомощность"],

    symbolism: [
      "Женщина с завязанными глазами и связанными руками",
      "Восемь мечей образуют заграждение",
      "Топкая почва"
    ],
    symbolismInterpretation: "Ментальные оковы, самоограничения и страхи",

    archetype: "Пленница мыслей",
    psychology: "Катастрофизация, выученная беспомощность",

    upright: {
      personality: "Неуверенность, зависимость от внешнего",
      relationships: "Страх говорить о важном",
      work: "Ограничения и бюрократия",
      spirituality: "Видеть свои ментальные ловушки",
      examples: ["Страх ошибки", "Зависимость от обстоятельств"]
    },
    reversed: {
      meaning: "Освобождение, снятие блоков",
      nuances: "Первые шаги к самостоятельности"
    },

    associations: ["Верёвки", "Повязка", "Лабиринт"],
    combinations: [
      "С Силой — преодоление страхов",
      "С Тузом Мечей — ясность, разрубающая путы"
    ],
    readingTips: [
      "Разделить реальные и воображаемые преграды",
      "Искать маленькие, но конкретные шаги"
    ],
    selfQuestions: [
      "Какая мысль держит меня в плену?",
      "Что я могу сделать уже сегодня?"
    ]
  },
{
    id: "swords_9",
    arcana: "minor",
    suit: "swords",
    court: "simple",
    number: 9,
    name: "Девятка Мечей",
    nameEn: "Nine of Swords",

    keywords: ["Тревога", "Вина", "Бессонница"],

    symbolism: [
      "Фигура сидит на кровати, закрыв лицо",
      "Девять мечей на стене",
      "Ночной интерьер"
    ],
    symbolismInterpretation: "Тяжёлые мысли, ночные переживания, чувство вины",

    archetype: "Ночная тревога",
    psychology: "Руминации, усиление страхов в одиночестве",

    upright: {
      personality: "Повышенная тревожность",
      relationships: "Страх утраты, ревность",
      work: "Стрессовые дедлайны",
      spirituality: "Осознанность через принятие боли",
      examples: ["Бессонная ночь", "Навязчивые мысли"]
    },
    reversed: {
      meaning: "Снижение тревоги, поддержка",
      nuances: "Запрос помощи, терапия"
    },

    associations: ["Ночь", "Кровать", "Слёзы"],
    combinations: [
      "С Луной — усиленная тревожность и иллюзии",
      "Со Звездой — надежда и исцеление"
    ],
    readingTips: [
      "Отделять факты от страхов",
      "Обратиться за поддержкой"
    ],
    selfQuestions: [
      "О чём кричат мои мысли?",
      "Кому я могу рассказать о своём страхе?"
    ]
  },
{
    id: "swords_10",
    arcana: "minor",
    suit: "swords",
    court: "simple",
    number: 10,
    name: "Десятка Мечей",
    nameEn: "Ten of Swords",

    keywords: ["Финал", "Крах", "Катарсис"],

    symbolism: [
      "Фигура, пронзённая десятью мечами",
      "Рассвет на горизонте",
      "Тёмное небо"
    ],
    symbolismInterpretation: "Болезненное завершение, но и намёк на новое утро",

    archetype: "Низшая точка",
    psychology: "Признание поражения как начало восстановления",

    upright: {
      personality: "Принятие неизбежного конца",
      relationships: "Окончательный разрыв",
      work: "Закрытие провального проекта",
      spirituality: "Отпускание эго",
      examples: ["Точка в истории", "Перегорание"]
    },
    reversed: {
      meaning: "Выход из кризиса, облегчение",
      nuances: "Медленное восстановление"
    },

    associations: ["Рассвет", "Падение", "Финал"],
    combinations: [
      "Со Смертью — глубокая трансформация",
      "Со Звездой — надежда после краха"
    ],
    readingTips: [
      "Не задерживаться в роли жертвы",
      "Смотреть в сторону рассвета"
    ],
    selfQuestions: [
      "Что завершилось окончательно?",
      "Чему меня научил этот финал?"
    ]
  },
{
    id: "swords_11",
    arcana: "minor",
    suit: "swords",
    court: "page",
    number: 11,
    name: "Паж Мечей",
    nameEn: "Page of Swords",

    keywords: ["Наблюдательность", "Идеи", "Бдительность"],

    symbolism: [
      "Юноша с поднятым мечом на ветреном холме",
      "Облака и птицы",
      "Готовность к движению"
    ],
    symbolismInterpretation: "Любопытство ума, сбор информации, готовность учиться",

    archetype: "Ученик разума",
    psychology: "Бдительность, настороженность к деталям",

    upright: {
      personality: "Сообразительность, острота ума",
      relationships: "Прямота, честные вопросы",
      work: "Исследование, аналитика",
      spirituality: "Наблюдение за мыслями",
      examples: ["Сбор фактов", "Старт обучения", "Разведка"]
    },
    reversed: {
      meaning: "Слежка, сплетни",
      nuances: "Поспешные выводы, болтливость"
    },

    associations: ["Ветер", "Птицы", "Холм"],
    combinations: [
      "С Тузом Мечей — рождение идеи",
      "С Семёркой Мечей — риск неэтичного сбора данных"
    ],
    readingTips: [
      "Проверять источники",
      "Формулировать точные вопросы"
    ],
    selfQuestions: [
      "Какие факты мне нужны?",
      "Где мои предположения вместо знаний?"
    ]
  },
{
    id: "swords_12",
    arcana: "minor",
    suit: "swords",
    court: "knight",
    number: 12,
    name: "Рыцарь Мечей",
    nameEn: "Knight of Swords",

    keywords: ["Стремительность", "Полемика", "Решимость"],

    symbolism: [
      "Всадник мчится с поднятым мечом",
      "Грозовые облака",
      "Флаги развеваются"
    ],
    symbolismInterpretation: "Прорыв через действие, напор в аргументах",

    archetype: "Воин идей",
    psychology: "Импульсивное мышление, горячность",

    upright: {
      personality: "Решительность, логичность",
      relationships: "Острые разговоры, честность",
      work: "Быстрые решения, кризис-менеджмент",
      spirituality: "Отстаивание принципов",
      examples: ["Дебаты", "Срочные задачи", "Рывок к цели"]
    },
    reversed: {
      meaning: "Поспешность, агрессия",
      nuances: "Конфликт без слушания оппонента"
    },

    associations: ["Гроза", "Флаг", "Конь"],
    combinations: [
      "С Колесницей — сверхскорость",
      "С Умеренностью — необходимость сдерживания"
    ],
    readingTips: [
      "Замедлиться и проверить факты",
      "Разделять прямоту и резкость"
    ],
    selfQuestions: [
      "Не тороплю ли я события?",
      "Слышу ли я другую сторону?"
    ]
  },
{
    id: "swords_13",
    arcana: "minor",
    suit: "swords",
    court: "queen",
    number: 13,
    name: "Королева Мечей",
    nameEn: "Queen of Swords",

    keywords: ["Объективность", "Чёткость", "Границы"],

    symbolism: [
      "Женщина с поднятым мечом и протянутой рукой",
      "Облака и птицы",
      "Трон с резьбой"
    ],
    symbolismInterpretation: "Трезвость ума, честная речь, независимость",

    archetype: "Суд разума",
    psychology: "Дистанция ради ясности, здоровые границы",

    upright: {
      personality: "Принципиальность, аналитичность",
      relationships: "Честный разговор, зрелость",
      work: "Редактура, анализ, стратегия",
      spirituality: "Отделение сути от лишнего",
      examples: ["Жёсткая, но справедливая оценка", "Отсечение лишнего"]
    },
    reversed: {
      meaning: "Холодность, критиканство",
      nuances: "Ранящие слова, ожесточение"
    },

    associations: ["Воздух", "Перо", "Острота"],
    combinations: [
      "Со Справедливостью — беспристрастное решение",
      "С Жрицей — мудрость и интуиция в паре"
    ],
    readingTips: [
      "Говорить правду без унижения",
      "Хранить ясные границы"
    ],
    selfQuestions: [
      "Где мне нужна твёрдость?",
      "Не стал(а) ли я слишком холодным(ой)?"
    ]
  },
{
    id: "swords_14",
    arcana: "minor",
    suit: "swords",
    court: "king",
    number: 14,
    name: "Король Мечей",
    nameEn: "King of Swords",

    keywords: ["Логика", "Закон", "Стратегия"],

    symbolism: [
      "Мужчина с мечом, сидящий прямо",
      "Бабочки и птицы",
      "Устойчивый трон"
    ],
    symbolismInterpretation: "Высшая форма рациональности и справедливого суждения",

    archetype: "Арбитр",
    psychology: "Эмоциональная сдержанность ради объективности",

    upright: {
      personality: "Честность, интеллектуальная сила",
      relationships: "Прозрачные правила и диалог",
      work: "Стратегические решения, консалтинг, право",
      spirituality: "Дисциплина ума",
      examples: ["Разработка политики", "Судейское решение", "Стратегический план"]
    },
    reversed: {
      meaning: "Жестокость ума, манипуляция логикой",
      nuances: "Злоупотребление властью, цинизм"
    },

    associations: ["Меч", "Закон", "Хладность"],
    combinations: [
      "С Императором — сильная власть и структура",
      "С Дьяволом — тирания рациональности"
    ],
    readingTips: [
      "Сочетать разум с эмпатией",
      "Следить за этикой решений"
    ],
    selfQuestions: [
      "Насколько мои решения справедливы?",
      "Где мне не хватает эмпатии?"
    ]
  }
];


